import React from "react";

interface LightningArrowIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const CheckIcon: React.FC<LightningArrowIconProps> = ({
  width = 10,
  height = 8,
  color = "white",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.78706 2.43332C2.40296 3.20019 3.02833 3.97825 3.75636 4.88487C5.33843 3.15254 6.77806 1.57659 8.218 0C8.98077 0.730732 9.52749 1.25488 10 1.70771C7.90183 3.84106 5.83368 5.94404 3.81131 8C2.59183 6.74352 1.31171 5.42405 0 4.07195C0.447554 3.66166 1.00629 3.14902 1.78706 2.43332Z"
        fill={color}
      />
    </svg>
  );
};

export default CheckIcon;
